export default __webpack_public_path__ + "static/media/Cow.ed76047c.png";